"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const mui_1 = require("tss-react/mui");
const Box_1 = __importDefault(require("@mui/material/Box"));
const Chip_1 = __importDefault(require("@mui/material/Chip"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Menu_1 = __importDefault(require("@mui/material/Menu"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const Table_1 = __importDefault(require("@mui/material/Table"));
const TableBody_1 = __importDefault(require("@mui/material/TableBody"));
const TableCell_1 = __importDefault(require("@mui/material/TableCell"));
const TableContainer_1 = __importDefault(require("@mui/material/TableContainer"));
const TableRow_1 = __importDefault(require("@mui/material/TableRow"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Check_1 = __importDefault(require("@mui/icons-material/Check"));
const MoreVert_1 = __importDefault(require("@mui/icons-material/MoreVert"));
const datasetSharesSelectors_1 = require("companion-app-components/flux/dataset-shares/datasetSharesSelectors");
const actions_1 = require("components/Dialogs/DatasetSharing/actions");
const userInfoSelectors_1 = require("companion-app-components/flux/user-info/userInfoSelectors");
const core_1 = require("companion-app-components/utils/core");
const entitlementsUtils_1 = require("companion-app-components/flux/entitlements/entitlementsUtils");
const constants_1 = require("utils/constants");
const utils_1 = require("./utils");
const styles_1 = __importDefault(require("./styles"));
const useStyles = (0, mui_1.makeStyles)()(styles_1.default);
const TableMyDatasets = ({ datasets, currentDataset, datasetsSharing, hoveredDataset, setHoveredDataset, onDatasetClick, }) => {
    var _a, _b;
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const [overflowAnchorEl, setOverflowAnchorEl] = (0, react_1.useState)(null);
    const [overflowSharings, setOverflowSharings] = (0, react_1.useState)([]);
    const open = Boolean(anchorEl);
    const overflowOpen = Boolean(overflowAnchorEl);
    const isLoadingSharedDatasets = (0, react_redux_1.useSelector)(datasetSharesSelectors_1.getLoadPending);
    const maximumSharesPerDataset = (_b = (_a = (0, react_redux_1.useSelector)(userInfoSelectors_1.getUserInfo)) === null || _a === void 0 ? void 0 : _a.get('maximumSharesPerDataset')) !== null && _b !== void 0 ? _b : 0;
    const dispatch = (0, react_redux_1.useDispatch)();
    const { classes } = useStyles();
    const handleMenuClick = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
        setHoveredDataset(undefined);
    };
    const handleOverflowOpen = (event, items) => {
        event.stopPropagation();
        setOverflowSharings(items);
        setOverflowAnchorEl(event.currentTarget);
    };
    const handleOverflowClose = () => {
        setOverflowAnchorEl(null);
        setOverflowSharings([]);
    };
    const getSharedUserLabel = (sharing) => {
        const hasExpiredInvite = checkIfInviteExpired(sharing === null || sharing === void 0 ? void 0 : sharing.lastInviteSent);
        const sharedUserFullName = `${(sharing === null || sharing === void 0 ? void 0 : sharing.granteeFirstName) || ''} ${(sharing === null || sharing === void 0 ? void 0 : sharing.granteeLastName) || ''}`.trim();
        if ((sharing === null || sharing === void 0 ? void 0 : sharing.state) === DATASET_SHARING_STATES.INVITED && hasExpiredInvite) {
            return `Invitation Expired - ${sharedUserFullName}`;
        }
        if ((sharing === null || sharing === void 0 ? void 0 : sharing.state) === DATASET_SHARING_STATES.INVITED) {
            return `Invited - ${sharedUserFullName}`;
        }
        if ((sharing === null || sharing === void 0 ? void 0 : sharing.state) === DATASET_SHARING_STATES.ABANDONED) {
            return `No longer shared - ${sharedUserFullName}`;
        }
        return sharedUserFullName;
    };
    const handleShareClick = (objDataset) => {
        dispatch((0, actions_1.showShareFinancesDialog)(objDataset));
        core_1.tracker.track(core_1.tracker.events.datasetSharing, { property: 'shareClicked' });
    };
    const handleManageAccess = () => {
        handleMenuClose();
        if (hoveredDataset) {
            dispatch((0, actions_1.showManageMembersDialog)({ dataset: hoveredDataset }));
        }
    };
    return (<Box_1.default sx={{ maxHeight: 300 }}>
      <TableContainer_1.default>
        <Table_1.default aria-label="my cloud accounts table">
          <TableBody_1.default>
            {datasets && datasets.valueSeq().map((objDataset) => {
            var _a;
            const isHoveredDataset = (hoveredDataset === null || hoveredDataset === void 0 ? void 0 : hoveredDataset.id) === objDataset.id;
            // TODO:: We should create a separate selector to combine found sharing record corresponding to each own dataset.
            const sharings = datasetsSharing === null || datasetsSharing === void 0 ? void 0 : datasetsSharing.filter((objDatasetSharing) => objDatasetSharing.datasetId === objDataset.id);
            const sharingsList = (_a = sharings === null || sharings === void 0 ? void 0 : sharings.valueSeq().toArray()) !== null && _a !== void 0 ? _a : [];
            const visibleSharings = sharingsList.slice(0, 3);
            const hiddenSharings = sharingsList.slice(3);
            const isCFODataset = (0, entitlementsUtils_1.hasCFOEntitlementForDataset)(objDataset === null || objDataset === void 0 ? void 0 : objDataset.entitlements);
            const disableShareOptions = (0, utils_1.shouldDisableShareOptions)(Number(sharings === null || sharings === void 0 ? void 0 : sharings.size), maximumSharesPerDataset, isCFODataset, (currentDataset === null || currentDataset === void 0 ? void 0 : currentDataset.id) === objDataset.id);
            return (<TableRow_1.default key={objDataset.id} onClick={() => onDatasetClick(objDataset)} onMouseOver={() => setHoveredDataset(objDataset)} onMouseLeave={() => {
                    if (!anchorEl) {
                        setHoveredDataset(undefined);
                    }
                }} sx={{
                    backgroundColor: hoveredDataset === objDataset ? 'babyBlue' : null,
                    cursor: 'pointer',
                }}>
                  <TableCell_1.default component="th" sx={{ p: 0, width: '1%' }}>
                    {currentDataset === objDataset ? <Check_1.default fontSize="small" color="success"/> : null}
                  </TableCell_1.default>
                  <TableCell_1.default component="th" scope="row" className={classes.textEllipsis} sx={{
                    width: '30%',
                    maxWidth: 200,
                }}>
                    {objDataset.name}
                  </TableCell_1.default>
                  <TableCell_1.default component="th" align="center" sx={{ width: '33%' }}>
                    {sharingsList.length > 0 && (<>
                        <Typography_1.default variant="body2" color="text.tertiary" component="span" mr={1}>
                          Shared with:
                        </Typography_1.default>
                        <Box_1.default display="inline-flex" flexWrap="wrap" gap={1}>
                          {visibleSharings.map((sharing) => {
                        var _a;
                        const { isInvited, invitedLabel, color } = (0, utils_1.getSharingInviteDisplay)(sharing);
                        const sharedUserFullName = (0, utils_1.getSharedUserFullName)(sharing === null || sharing === void 0 ? void 0 : sharing.granteeFirstName, sharing === null || sharing === void 0 ? void 0 : sharing.granteeLastName);
                        return (<Chip_1.default key={(_a = sharing === null || sharing === void 0 ? void 0 : sharing.id) !== null && _a !== void 0 ? _a : sharedUserFullName} size="small" label={(<>
                                    {isInvited && (<Typography_1.default component="span" variant="body2" color={color}>
                                        {invitedLabel}
                                      </Typography_1.default>)}
                                    <Typography_1.default component="span" variant="body2" color={isInvited ? 'text.tertiary' : 'text.primary'}>
                                      {sharedUserFullName}
                                    </Typography_1.default>
                                  </>)} className={classes.sharedUserChip}/>);
                    })}
                          {hiddenSharings.length > 0 && (<Chip_1.default size="small" label={`+${hiddenSharings.length}`} onClick={(event) => handleOverflowOpen(event, hiddenSharings)} className={`${classes.sharedUserChip} ${classes.sharedUserChipOverflow}`}/>)}
                        </Box_1.default>
                      </>)}
                  </TableCell_1.default>
                  <TableCell_1.default component="th" align="right" sx={{ p: 0, width: '30%' }}>
                    <Typography_1.default variant="body2" color="text.tertiary" component="span" mr={2}>
                      Last Synced: {objDataset.lastSyncedAt ? (0, utils_1.formatLastSyncedDate)(objDataset.lastSyncedAt) : constants_1.APP_STRING_NOT_APPLICABLE}
                    </Typography_1.default>
                  </TableCell_1.default>
                  {!isLoadingSharedDatasets && (<>
                      <TableCell_1.default component="th" align="right" sx={{
                        p: 0,
                    }}>
                        <Chip_1.default size="small" label="Share" color={disableShareOptions ? 'default' : 'primary'} disabled={disableShareOptions} onClick={(e) => {
                        e.stopPropagation();
                        handleShareClick(objDataset);
                    }} sx={{
                        color: 'primary.contrastText',
                        backgroundColor: disableShareOptions ? 'icon.secondary' : 'action.surface',
                        visibility: isHoveredDataset ? 'visible' : 'hidden',
                    }}/>
                      </TableCell_1.default>
                      <TableCell_1.default component="th" sx={{
                        p: 0,
                        width: 20,
                    }}>
                        <IconButton_1.default onClick={(e) => handleMenuClick(e)} disabled={(isCFODataset && (currentDataset === null || currentDataset === void 0 ? void 0 : currentDataset.id) !== objDataset.id)} sx={{
                        visibility: isHoveredDataset ? 'visible' : 'hidden',
                    }}>
                          <MoreVert_1.default fontSize="small"/>
                        </IconButton_1.default>
                      </TableCell_1.default>
                    </>)}
                </TableRow_1.default>);
        })}
          </TableBody_1.default>
        </Table_1.default>
      </TableContainer_1.default>
      <Menu_1.default id="shared-with-overflow-menu" anchorEl={overflowAnchorEl} open={overflowOpen} onClose={handleOverflowClose} slotProps={{
            paper: {
                style: {
                    width: '28ch',
                },
            },
        }}>
        {overflowSharings.map((sharing) => {
            var _a;
            const label = getSharedUserLabel(sharing);
            return (<MenuItem_1.default key={(_a = sharing === null || sharing === void 0 ? void 0 : sharing.id) !== null && _a !== void 0 ? _a : label}>
              <Typography_1.default variant="body2" color="text.primary">
                {label}
              </Typography_1.default>
            </MenuItem_1.default>);
        })}
      </Menu_1.default>
      <Menu_1.default id="own-dataset-menu" anchorEl={anchorEl} open={open} onClose={handleMenuClose} slotProps={{
            paper: {
                style: {
                    width: '28ch',
                },
            },
        }}>
        <MenuItem_1.default onClick={handleManageAccess} sx={{
            '&:hover': {
                backgroundColor: 'babyBlue',
            },
        }}>
          Manage Access
        </MenuItem_1.default>
      </Menu_1.default>
    </Box_1.default>);
};
exports.default = TableMyDatasets;
